function IconsPage() {
    return (
        <>
            <div className="section-content p-t120 p-b90 twm-icons-font-wrap">
                <div className="container">
                    <div className="wt-box">
                        <div className="icon-font no-gutters row d-flex justify-content-center flex-wrap m-b30">
                            {/*1*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-dashboard" />
                                    <div className="class-name">.flaticon-dashboard</div>
                                </div>
                            </div>
                            {/*2*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-project-management" />
                                    <div className="class-name">.flaticon-project-management</div>
                                </div>
                            </div>
                            {/*3*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-note" />
                                    <div className="class-name">.flaticon-note</div>
                                </div>
                            </div>
                            {/*4*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-customer-support" />
                                    <div className="class-name">.flaticon-customer-support</div>
                                </div>
                            </div>
                            {/*5*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-job-search" />
                                    <div className="class-name">.flaticon-job-search</div>
                                </div>
                            </div>
                            {/*6*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-job-description" />
                                    <div className="class-name">.flaticon-job-description</div>
                                </div>
                            </div>
                            {/*7*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-job" />
                                    <div className="class-name">.flaticon-job</div>
                                </div>
                            </div>
                            {/*8*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-job-seeker" />
                                    <div className="class-name">.flaticon-job-seeker</div>
                                </div>
                            </div>
                            {/*9*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-resume" />
                                    <div className="class-name">.flaticon-resume</div>
                                </div>
                            </div>
                            {/*10*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-cv" />
                                    <div className="class-name">.flaticon-cv</div>
                                </div>
                            </div>
                            {/*11*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-cv-1" />
                                    <div className="class-name">.flaticon-cv-1</div>
                                </div>
                            </div>
                            {/*12*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-bars" />
                                    <div className="class-name">.flaticon-bars</div>
                                </div>
                            </div>
                            {/*13*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-user" />
                                    <div className="class-name">.flaticon-user</div>
                                </div>
                            </div>
                            {/*14*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-computer" />
                                    <div className="class-name">.flaticon-computer</div>
                                </div>
                            </div>
                            {/*15*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-coding" />
                                    <div className="class-name">.flaticon-coding</div>
                                </div>
                            </div>
                            {/*16*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-hr" />
                                    <div className="class-name">.flaticon-hr</div>
                                </div>
                            </div>
                            {/*17*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-hr-manager" />
                                    <div className="class-name">.flaticon-hr-manager</div>
                                </div>
                            </div>
                            {/*18*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-healthcare" />
                                    <div className="class-name">.flaticon-healthcare</div>
                                </div>
                            </div>
                            {/*19*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-repair" />
                                    <div className="class-name">.flaticon-repair</div>
                                </div>
                            </div>
                            {/*20*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-teacher" />
                                    <div className="class-name">.flaticon-teacher</div>
                                </div>
                            </div>
                            {/*21*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-bank" />
                                    <div className="class-name">.flaticon-bank</div>
                                </div>
                            </div>
                            {/*22*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-deal" />
                                    <div className="class-name">.flaticon-deal</div>
                                </div>
                            </div>
                            {/*23*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-tray" />
                                    <div className="class-name">.flaticon-tray</div>
                                </div>
                            </div>
                            {/*24*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-tower" />
                                    <div className="class-name">.flaticon-tower</div>
                                </div>
                            </div>
                            {/*25*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-lotus" />
                                    <div className="class-name">.flaticon-lotus</div>
                                </div>
                            </div>
                            {/*26*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-camera-tripod" />
                                    <div className="class-name">.flaticon-camera-tripod</div>
                                </div>
                            </div>
                            {/*27*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-multimedia" />
                                    <div className="class-name">.flaticon-multimedia</div>
                                </div>
                            </div>
                            {/*28*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-contract" />
                                    <div className="class-name">.flaticon-contract</div>
                                </div>
                            </div>
                            {/*29*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-engineer" />
                                    <div className="class-name">.flaticon-engineer</div>
                                </div>
                            </div>
                            {/*30*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-pdf" />
                                    <div className="class-name">.flaticon-pdf</div>
                                </div>
                            </div>
                            {/*31*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-pdf-1" />
                                    <div className="class-name">.flaticon-pdf-1</div>
                                </div>
                            </div>
                            {/*32*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-doc" />
                                    <div className="class-name">.flaticon-doc</div>
                                </div>
                            </div>
                            {/*33*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-zip" />
                                    <div className="class-name">.flaticon-zip</div>
                                </div>
                            </div>
                            {/*34*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-apk" />
                                    <div className="class-name">.flaticon-apk</div>
                                </div>
                            </div>
                            {/*35*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-jpg" />
                                    <div className="class-name">.flaticon-jpg</div>
                                </div>
                            </div>
                            {/*36*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-php" />
                                    <div className="class-name">.flaticon-php</div>
                                </div>
                            </div>
                            {/*37*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-css" />
                                    <div className="class-name">.flaticon-css</div>
                                </div>
                            </div>
                            {/*38*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-png" />
                                    <div className="class-name">.flaticon-png</div>
                                </div>
                            </div>
                            {/*39*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-xls" />
                                    <div className="class-name">.flaticon-xls</div>
                                </div>
                            </div>
                            {/*40*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-ppt" />
                                    <div className="class-name">.flaticon-ppt</div>
                                </div>
                            </div>
                            {/*41*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-txt" />
                                    <div className="class-name">.flaticon-txt</div>
                                </div>
                            </div>
                            {/*42*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-html-document" />
                                    <div className="class-name">.flaticon-html-document</div>
                                </div>
                            </div>
                            {/*43*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-hand-phone" />
                                    <div className="class-name">.flaticon-hand-phone</div>
                                </div>
                            </div>
                            {/*44*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-smartphone-1" />
                                    <div className="class-name">.flaticon-smartphone-1</div>
                                </div>
                            </div>
                            {/*45*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-smartphone" />
                                    <div className="class-name">.flaticon-smartphone</div>
                                </div>
                            </div>
                            {/*46*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-telephone" />
                                    <div className="class-name">.flaticon-telephone</div>
                                </div>
                            </div>
                            {/*47*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-phone" />
                                    <div className="class-name">.flaticon-phone</div>
                                </div>
                            </div>
                            {/*48*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-email" />
                                    <div className="class-name">.flaticon-email</div>
                                </div>
                            </div>
                            {/*49*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-envelope" />
                                    <div className="class-name">.flaticon-envelope</div>
                                </div>
                            </div>
                            {/*50*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-minus" />
                                    <div className="class-name">.flaticon-minus</div>
                                </div>
                            </div>
                            {/*51*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-plus" />
                                    <div className="class-name">.flaticon-plus</div>
                                </div>
                            </div>
                            {/*52*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-map-2" />
                                    <div className="class-name">.flaticon-map-2</div>
                                </div>
                            </div>
                            {/*53*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-map-1" />
                                    <div className="class-name">.flaticon-map-1</div>
                                </div>
                            </div>
                            {/*54*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-map" />
                                    <div className="class-name">.flaticon-map</div>
                                </div>
                            </div>
                            {/*55*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-left-quote" />
                                    <div className="class-name">.flaticon-left-quote</div>
                                </div>
                            </div>
                            {/*56*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-right-quote" />
                                    <div className="class-name">.flaticon-right-quote</div>
                                </div>
                            </div>
                            {/*57*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-upload" />
                                    <div className="class-name">.flaticon-upload</div>
                                </div>
                            </div>
                            {/*58*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-file" />
                                    <div className="class-name">.flaticon-file</div>
                                </div>
                            </div>
                            {/*59*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-down-arrow" />
                                    <div className="class-name">.flaticon-down-arrow</div>
                                </div>
                            </div>
                            {/*60*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-up-arrow" />
                                    <div className="class-name">.flaticon-up-arrow</div>
                                </div>
                            </div>
                            {/*61*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-chevron" />
                                    <div className="class-name">.flaticon-chevron</div>
                                </div>
                            </div>
                            {/*62*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-left-chevron" />
                                    <div className="class-name">.flaticon-left-chevron</div>
                                </div>
                            </div>
                            {/*63*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-edit-1" />
                                    <div className="class-name">.flaticon-edit-1</div>
                                </div>
                            </div>
                            {/*64*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-edit" />
                                    <div className="class-name">.flaticon-edit</div>
                                </div>
                            </div>
                            {/*65*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-enter" />
                                    <div className="class-name">.flaticon-enter</div>
                                </div>
                            </div>
                            {/*66*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-sign-in" />
                                    <div className="class-name">.flaticon-sign-in</div>
                                </div>
                            </div>
                            {/*67*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-magnifying-glass" />
                                    <div className="class-name">.flaticon-magnifying-glass</div>
                                </div>
                            </div>
                            {/*68*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-search-interface-symbol" />
                                    <div className="class-name">.flaticon-search-interface-symbol</div>
                                </div>
                            </div>
                            {/*69*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-bell-1" />
                                    <div className="class-name">.flaticon-bell-1</div>
                                </div>
                            </div>
                            {/*70*/}
                            <div className="col-md-3 col-sm-6">
                                <div className="icon-font-block">
                                    <div className="flaticon-bell" />
                                    <div className="class-name">.flaticon-bell</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default IconsPage;